const PUBLIC_PATHS = new Set(['/', '/register', '/forgotPassword', '/setPassword']);

export const isPublicPath = (pathname) => {
  if (PUBLIC_PATHS.has(pathname)) return true;
  return pathname.startsWith('/resetPassword');
};

export const clearAuthSession = () => {
  sessionStorage.clear();
};

const isPageReload = () => {
  const navEntry = performance.getEntriesByType('navigation')[0];
  return navEntry?.type === 'reload';
};

/**
 * Runs before React mounts on full page loads.
 * Redirects to login when the tab has no auth token, or when the tab was
 * duplicated (sessionStorage copied while Redux is empty — hasRefreshed stays set
 * because beforeunload only runs on refresh/close, not on duplicate).
 */
export const enforceSessionOnLoad = () => {
  const { pathname } = window.location;
  if (isPublicPath(pathname)) return;

  const token = sessionStorage.getItem('qmetrix-token');
  if (!token) {
    clearAuthSession();
    window.location.replace('/');
    return;
  }

  const hasRefreshed = sessionStorage.getItem('hasRefreshed');
  if (hasRefreshed === 'true' && !isPageReload()) {
    clearAuthSession();
    window.location.replace('/');
  }
};
